<div class="background-transparent">
  <div siqGrid fx-direction="row" [class]="cardClasses" [class.border-primary-400]="hasBorder">
    <span [class]="cardIcon"></span>
    @if(isDYK) {
      <ng-container>
        <div siqGrid fx-direction="column" fx-layout-align="center center" [class]="infoBoxClasses">
          <img class="image" [src]="image" alt="IMAGE">
        </div>
      </ng-container>
    }
    <div siqGrid fx-direction="column" class="w-100-p p-12">
      @if(headerText) {
        <ng-container>
          <span class="siq-text-700" [class]="headerTextSize" [innerHTML]="headerText"></span>
        </ng-container>
      }
      @if(text) {
        <span
          [class]="textClasses"
          [innerHTML]="text">
        </span>
      }

      <div siqGrid fx-direction="row" class="w-100-p">
          <ng-content select="div.body"></ng-content>
      </div>

      @if(btnText) {
        <ng-container>
          <div siqGrid fx-layout-align="end center" [class]="btnMargin">
            <app-siq-button
              [text]="btnText"
              [btnType]="btnType"
              (buttonClicked)="onClick()"
              />
          </div>
        </ng-container>
      }
    </div>
  </div>
</div>